import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import Preload from '../preload/Preload';
import axios from 'axios';
import Input from './Input';
import {formataLogradouro, preparaEndereco} from '../../../helper/Formatar';

class InputCep extends AbstractComponent {    
    constructor(props) {
        super(props);

        this.state = {
            preload: false
        }
    }          

    onChange(input) {        
        if (this.props.onChange !== undefined) {
          this.props.onChange(input);
        }
    }    

    onBlur(input) {        
        if (this.props.onBlur !== undefined) {
            const cep = input.target.value;                         
        
            if(cep === '')
                return ;                            

            this.setState({preload: true});

            axios.get('https:///viacep.com.br/ws/' + cep + '/json/').then(response => {                                                        
                let endereco = [];                                                

                endereco['cep'] = cep;                
                endereco['logradouro'] = formataLogradouro(this.props.logradouros, response.data.logradouro); 
                endereco['endereco'] = preparaEndereco(endereco['logradouro'], response.data.logradouro); 
                endereco['bairro'] = response.data.bairro;
                endereco['cidade'] = response.data.localidade;
                endereco['uf'] = response.data.uf;                                
                
                this.props.onBlur(endereco);

                this.setState({preload: false});    
                
                if(this.props.proxFocoId !== undefined)                     
                    this.foco(this.props.proxFocoId);                    
            }).catch(error => {                
                this.setState({preload: false});                

                if(this.props.onErro !== undefined)
                    this.props.onErro("Erro ao buscar cep ou cep não encontrado. Certifique que o cep digitado é válido!");
            }) ;          
        }
    }       

    componentDidMount() {
        this.foco(this.props.nome);
    }

    render() {
        return (
            <Fragment>
                <Preload show={this.state.preload} />

                <Input
                    md={this.props.md}
                    xs={this.props.xs} 
                    sm={this.props.sm}
                    lg={this.props.lg}
                    style={this.props.style}
                    classNameInput={this.props.classNameInput}
                    maxLength={this.props.maxLength}
                    type="text"
                    id={this.props.id}
                    nome={this.props.nome}                    
                    value={this.props.value}
                    defaultValue={this.props.defaultValue}
                    erro={this.props.erro}
                    disabled={this.props.disabled}

                    onChange={e => this.onChange(e)}
                    onBlur={e => this.onBlur(e)}>
                    {this.props.children}
                </Input>                  
            </Fragment>
        )
    }
}

export default InputCep;